
import React, { Component } from "react";
import { Link,Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import Navbar from "./components/Navbar";
import FilterBy from "./components/FilterBy";

import Customercreatemodal from "./components/Customercreatemodal";
import Customerlist from "./components/Customerlist";

import Forgetpassword from "./components/Forgetpassword";
import Resetpassword from "./components/Resetpassword";

import Vendorscreatemodal from "./components/Vendorscreatemodal";
import Emailverification from "./components/Emailverification";
import Vendorslist from "./components/Vendorslist";


import Employeemodalcreate from "./components/Employeemodalcreate";
import Employeemodaledit from "./components/Employeemodaledit";
import Employeelist from "./components/Employeelist";

import ItemModalcreate from "./components/ItemModalcreate";

import ItemList from "./components/ItemList";

import ItemModaledit from "./components/ItemModaledit";
import Test from "./components/Test";
import Test1 from "./components/Test1";

import Invoice from "./components/Invoice";
import InvoiceList from "./components/InvoiceList";
import Invoiceview from "./components/Invoiceview";
import InvoiceEdit from "./components/InvoiceEdit";
import InvoicefeedbackquestionList from "./components/InvoicefeedbackquestionList";
import InvoicequestionCreatemodal from "./components/InvoicequestionCreatemodal";
import InvoicequestionEditmodal from "./components/InvoicequestionEditmodal";

import Invoicerecordpayment from "./components/Invoicerecordpayment";
import InvoicerecordpaymentEdit from "./components/InvoicerecordpaymentEdit";
import InvoicefeedbackModal from "./components/InvoicefeedbackModal";
import InvoiceFeedbacklist from "./components/InvoiceFeedbacklist";
import Purchaseorder from "./components/Purchaseorder";
import Purchaseorderlist from "./components/Purchaseorderlist";
import Purchaseorderview from "./components/Purchaseorderview";
import PurchaseorderEdit from "./components/PurchaseorderEdit";
import Lead from "./components/Lead";

import LeadList from "./components/LeadList";

import Dashboard from "./components/Dashboard";
import Organizationprofile from "./components/Organizationprofile";
import BranchList from "./components/BranchList";


import Purchaseordertobill from "./components/Purchaseordertobill";
import Billslist from "./components/Billslist";
import Billcreate from "./components/Billcreate";
import Billview from "./components/Billview";
import BillEdit from "./components/BillEdit";
import Billrecordpayment from "./components/Billrecordpayment";
import Billrecordpaymentedit from "./components/Billrecordpaymentedit";
import WarehouseList from "./components/WarehouseList";
import WarehouseCreatemodal from "./components/WarehouseCreatemodal";
import WarehouseEditmodal from "./components/WarehouseEditmodal";

import ExpenseList from "./components/ExpenseList";
import ExpenseCreatemodal from "./components/ExpenseCreatemodal";
import ExpenseEditmodal from "./components/ExpenseEditmodal";
import InventoryadjustmentsList from "./components/InventoryadjustmentsList";
import InventoryCreatemodal from "./components/InventoryCreatemodal";
import InventoryEditmodal from "./components/InventoryEditmodal";
import InventorytranferList from "./components/InventorytranferList";
import InventorytransferCreatemodal from "./components/InventorytransferCreatemodal";
import InventorytransferEditmodal from "./components/InventorytransferEditmodal";
import axios from "axios";

import BrandList from "./components/BrandList";
import DepositedList from "./components/DepositedList";
import SettingPage from "./components/SettingPage";
import ManufacturersList from "./components/ManufacturersList";
import LeadsourceList from "./components/LeadsourceList";
import LeadstatusList from "./components/LeadstatusList";
import Leadmodalcreate from "./components/Leadmodalcreate";
import Leadmodaledit from "./components/Leadmodaledit";
import ModeofpaymentList from "./components/ModeofpaymentList";
import ExpensecateList from "./components/ExpensecateList";
import Branchmodalcreate from "./components/Branchmodalcreate";
import BranchEditmodal from "./components/BranchEditmodal";
import Reasonlist from "./components/Reasonlist";
import Fiforeport from "./components/Fiforeport";
import ServicetypeList from "./components/ServicetypeList";
import CustomerfeedbackModal from "./components/CustomerfeedbackModal";
import CustomervehicleList from "./components/CustomervehicleList";
import Customervehiclemodalcreate from "./components/Customervehiclemodalcreate";
import CustomervehiclemodalEdit from "./components/CustomervehiclemodalEdit";
import CustomerfeedbackModalEdit from "./components/CustomerfeedbackModalEdit";
import FeedbackcallStatus from "./components/FeedbackcallStatus";
import FeedbackstatusList from "./components/FeedbackstatusList";
import Enquire from "./components/Enquire";
import EnquireList from "./components/EnquireList";
import EnquireView from "./components/EnquireView";
import EnquireEdit from "./components/EnquireEdit";
import CustomerratingoneList from "./components/CustomerratingoneList";
import CustomerratingtwoList from "./components/CustomerratingtwoList";
import Preferences from "./components/Preferences";
import InvoiceNumbermodal from "./components/InvoiceNumbermodal";
import CustomerprofileView from "./components/CustomerprofileView";

import {ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {  WifiIcon} from "@heroicons/react/solid";
{
  
  axios.defaults.baseURL = 'https://dreamsbusinesscrmv1.dreamsdigitall.com/api/20/mgtyres/';
  // axios.defaults.baseURL = ' https://mg.bizma.biz/api/5/mgtyres/';
  //axios.defaults.baseURL = 'http://localhost/mgtyres/';
  
  axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });


  axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
   
    return response;
  }, function (error) {
     
    const customId = "custom-id-yes";
    if (error.response.status === 401) {
          localStorage.removeItem("token");
          window.location.href = '/crm';
    }
      if (error.response.status == 0) {
          //alert("Check  your network connection");
      //window.confirm("Check  your network connection")
      toast.warn("Check  your network connection !", {
        position: toast.POSITION.TOP_RIGHT,
        icon: WifiIcon,
        toastId: customId
      });
  }
   
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });
/*  axios.defaults.withCredentials=true;
axios.interceptors.request.use( function (config){
const token=localStorage.getItem('token');
config.headers.Accept='application/json';
config.headers.Authorization =token ? `Bearer ${token}`  : '';
});
*/
}



function App() {
  return (
    
     <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Dashboard" element={<Dashboard />} />
        <Route path="/Register" element={<Register />} />
        
        <Route path="/Customercreatemodal" element={<Customercreatemodal />} />
        <Route path="/Customerlist" element={<Customerlist />} />
        
        <Route path="/Forgetpassword" element={<Forgetpassword />} />
        <Route path="/Resetpassword/:id" element={<Resetpassword />} />
        <Route path="/Emailverification/:id" element={<Emailverification />} />
        
        <Route path="/Vendorscreatemodal" element={<Vendorscreatemodal />} />
        <Route path="/Vendorslist" element={<Vendorslist />} />
        
        
        <Route path="/Employeemodalcreate" element={<Employeemodalcreate />} />
        <Route path="/Employeemodaledit" element={<Employeemodaledit />} />
        <Route path="/Employeelist" element={<Employeelist />} />
        
        
        <Route path="/ItemModalcreate" element={<ItemModalcreate />} />
        <Route path="/ItemModaledit" element={<ItemModaledit />} />
        <Route path="/ItemList" element={<ItemList />} />
        
        <Route path="/Test1" element={<Test1 />} />
        <Route path="/Test" element={<Test />} />
        <Route path="/Invoice" element={<Invoice />} />
        <Route path="/InvoiceList" element={<InvoiceList />} />
        <Route path="/Invoiceview/:id" element={<Invoiceview />} />
        <Route path="/InvoiceEdit/:id" element={<InvoiceEdit />} />
        <Route path="/Invoicerecordpayment/:id" element={<Invoicerecordpayment />} />
        <Route path="/InvoicerecordpaymentEdit/:id" element={<InvoicerecordpaymentEdit />} />
        <Route path="/InvoicefeedbackModal" element={<InvoicefeedbackModal />} />
        <Route path="/InvoiceFeedbacklist" element={<InvoiceFeedbacklist />} />
        <Route path="/InvoicefeedbackquestionList" element={<InvoicefeedbackquestionList />} />
        <Route path="/InvoicequestionCreatemodal" element={<InvoicequestionCreatemodal />} />
        <Route path="/InvoicequestionEditmodal" element={<InvoicequestionEditmodal />} />
        
        <Route path="/Purchaseorder" element={<Purchaseorder />} />
        <Route path="/Purchaseorderlist" element={<Purchaseorderlist />} />
        <Route path="/Purchaseorderview/:id" element={<Purchaseorderview />} />
        <Route path="/PurchaseorderEdit/:id" element={<PurchaseorderEdit />} />
        <Route path="/Lead" element={<Lead />} />
        <Route path="/Leadmodalcreate" element={<Leadmodalcreate />} />
        <Route path="/Leadmodaledit" element={<Leadmodaledit />} />
        <Route path="/LeadList" element={<LeadList />} />
        <Route path="/Organizationprofile" element={<Organizationprofile />} />
        <Route path="/BranchList" element={<BranchList />} />
        <Route path="/Branchmodalcreate" element={<Branchmodalcreate />} />
        <Route path="/BranchEditmodal" element={<BranchEditmodal />} />
        <Route path="/BrandList" element={<BrandList />} />
        <Route path="/Billrecordpayment/:id" element={<Billrecordpayment />} />
        <Route path="/Billview/:id" element={<Billview />} />
        <Route path="/Purchaseordertobill/:id" element={<Purchaseordertobill />} />
        <Route path="/Billslist" element={<Billslist />} />
        <Route path="/Billcreate" element={<Billcreate />} />
        <Route path="/BillEdit/:id" element={<BillEdit />} />
        <Route path="/Billrecordpaymentedit/:id" element={<Billrecordpaymentedit />} />
        <Route path="/WarehouseList" element={<WarehouseList />} />
        <Route path="/WarehouseCreatemodal" element={<WarehouseCreatemodal />} />
        <Route path="/WarehouseEditmodal" element={<WarehouseEditmodal />} />
        <Route path="/ExpenseList" element={<ExpenseList />} />
        <Route path="/ExpenseCreatemodal" element={<ExpenseCreatemodal />} />
        <Route path="/ExpenseEditmodal" element={<ExpenseEditmodal />} />
        <Route path="/InventoryadjustmentsList" element={<InventoryadjustmentsList />} />
        <Route path="/InventoryCreatemodal" element={<InventoryCreatemodal />} />
        <Route path="/InventoryEditmodal" element={<InventoryEditmodal />} />
        <Route path="/InventorytranferList" element={<InventorytranferList />} />
        <Route path="/InventorytransferCreatemodal" element={<InventorytransferCreatemodal />} />
        <Route path="/InventorytransferEditmodal" element={<InventorytransferEditmodal />} />
        <Route path="/SettingPage" element={<SettingPage />} />
        <Route path="/ManufacturersList" element={<ManufacturersList />} />
        <Route path="/LeadsourceList" element={<LeadsourceList />} />
        <Route path="/LeadstatusList" element={<LeadstatusList />} />
        <Route path="/ModeofpaymentList" element={<ModeofpaymentList />} />
        <Route path="/ExpensecateList" element={<ExpensecateList />} />
       
       <Route path="/DepositedList" element={<DepositedList />} />
       <Route path="/Reasonlist" element={<Reasonlist />} />
       <Route path="/Fiforeport" element={<Fiforeport />} />
       <Route path="/Navbar" element={<Navbar />} />
       <Route path="/FilterBy/:filterby" element={<FilterBy />} />
       <Route path="/FilterBy/:filterby/:id" element={<FilterBy />} />
       <Route path="/ServicetypeList" element={<ServicetypeList />} />
       <Route path="/CustomerfeedbackModal" element={<CustomerfeedbackModal />} />
       <Route path="/CustomervehicleList" element={<CustomervehicleList />} />
       <Route path="/Customervehiclemodalcreate" element={<Customervehiclemodalcreate />} />
       <Route path="/CustomerfeedbackModalEdit" element={<CustomerfeedbackModalEdit />} />
       <Route path="/CustomervehiclemodalEdit" element={<CustomervehiclemodalEdit />} />
       <Route path="/FeedbackcallStatus" element={<FeedbackcallStatus />} />
       <Route path="/FeedbackstatusList" element={<FeedbackstatusList />} />
       <Route path="/Enquire" element={<Enquire />} />
       <Route path="/EnquireList" element={<EnquireList />} />
       <Route path="/EnquireView/:id" element={<EnquireView />} />
       <Route path="/EnquireEdit/:id" element={<EnquireEdit />} />
       <Route path="/CustomerratingoneList" element={<CustomerratingoneList />} />
       <Route path="/CustomerratingtwoList" element={<CustomerratingtwoList />} />
       <Route path="/Preferences" element={<Preferences />} />
       <Route path="/InvoiceNumbermodal" element={<InvoiceNumbermodal />} />
       <Route path="/CustomerprofileView/:id" element={<CustomerprofileView />} />

       </Routes>
  );
}

export default App;
